<template>
  <div class="container-fluid">
    <div class="panel panel-info">
      <div style="text-align: left" class="p-3 mb-2 bg-secondary text-white">
        <b>Appointment:</b>
      </div>
      <form>
        <form action="/action_page.php">
          <table>
          <tr>
            <td width="45%" style="text-align: left">Tag No</td>
            <td width="1%" style="text-align:left">:</td>
            <td width="54%" style="text-align:left">
            <input type="text" id="Tname" name="Tname"  disabled>
            </td>
          </tr>
          <tr>
            <td width="45%" style="text-align: left">Owner</td>
            <td width="1%" style="text-align:left">:</td>
            <td width="54%" style="text-align:left">
            <input type="text" id="Tname" name="Tname" disabled > </td>
          </tr>
          <tr>
            <td width="45%" style="text-align: left">Appointment Type</td>
             <td width="1%" style="text-align:left">:</td>
            <td width="54%" style="text-align:left">
             <select input type="text" id="name" name="Aname" style="width:97%">
              <option value="Vaccination">Vaccination</option>
              <option value="OPD"> OPD</option>
              <option value="A.I">A.I</option>
              <option value="General Visit">General Visit</option>
            </select>
             </td>
          </tr>

          <tr>
            <td width="45%" style="text-align: left">Appointment Date</td>
            <td width="1%" style="text-align:left">:</td> 
            <td width="54%" style="text-align:left">
            <input type="text" id="Tname" name="Tname" disabled>
            </td>
          </tr>
          </table>
        </form>
      </form>
      <button type="submit" style="float: right" class="btn btn-primary">
        Submit
      </button>
    </div>
  </div>
</template>

<script>
import * as _ from "lodash";

//import ApplicationFilter from "../components/ApplicationFilter.vue";
//import MarksEntry from "../components/MarksEntry.vue";
//alert(1);
export default {
  data() {
    return{
      
    }
  },
  computed: {},
  methods: {
    reset_details() {
      this.Observations = "";
    },
  },
};
</script>

<style>
table {
  font-family: arial, sans-serif;

  width: 100%;
}

td,
th {
  border: 0px solid #dddddd;
  text-align: left;
  padding: 2px;
}
.mycard {
  padding-top: 5px;
  padding-bottom: 5px;
}
</style>
